import React from "react";
import "./BookingFlowControls.scss";

// Display-only progress indicator for the three-step booking flow: three dots,
// the current one red, completed ones dimmed. The step names are deliberately
// NOT shown — the page title right above already names the step (John,
// Aug 25 2026, picked from seven mockups). Not interactive: no links, no
// buttons, no navigation — the button row at the bottom of the card is the
// only way to move between steps.
export const BOOKING_STEPS = [
  "Job Details",
  "Location & Payment",
  "Review & Confirm",
];

// current: 1-based index of the step being shown.
const BookingSteps = ({ current }) => {
  const total = BOOKING_STEPS.length;

  return (
    <div
      className="booking_steps"
      role="group"
      aria-label={`Step ${current} of ${total}: ${BOOKING_STEPS[current - 1]}`}
    >
      {/* aria-hidden: the wrapper above already announces the position. */}
      <div className="booking_steps_dots" aria-hidden="true">
        {BOOKING_STEPS.map((name, i) => {
          const step = i + 1;
          const state =
            step === current ? "is_current" : step < current ? "is_done" : "is_upcoming";
          return <span key={name} className={`booking_steps_dot ${state}`} />;
        })}
      </div>
    </div>
  );
};

export default BookingSteps;
